module.exports = __webpack_public_path__ + "static/media/001-correct.f1c80c94.png";